// Sales admins that can be picked as "Closed By" across the CRM.
// Keep in sync with the CRM user list (Admin Panel → Users).
export const SALES_ADMINS = ['Syakir', 'Ira', 'Hana', 'Alia', 'Winda', 'Bihah'];
